<template>
  <div class="TransactionRecord">
    <div class="TransactionRecord_head">
      <div
        class="TransactionRecord_head_date"
        @click="seleteTransaction()"
      >
        <div>{{ date }}</div>
        <i class="iconfont icon-xia icon_account"></i>
      </div>
    </div>
    <div class="Card_soll">
      <van-list
        v-model="loading"
        :finished="finished"
        ref="list"
        :offset="1"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <Card
          v-for="(e, index) in tranDetailList"
          :key="index"
          :data="e"
          :isStatus="e.debit_flag == '0' ? false : true"
          :account="e.trans_amt"
          :time="e.tran_time"
          isSuccess="交易成功"
        />
      </van-list>
    </div>
    <Popover
      :isPopover="isPopover"
      @close="close()"
    >
      <template v-slot:title>
        <div class="popover_tabs">
          <div
            class="popover_tabs_item"
            @click="clickTabs(index)"
            :class="{ active: chooseIndex === index }"
            v-for="(e, index) in tabList"
            :key="e"
          >
            {{ e }}
          </div>
        </div>
      </template>
      <template v-slot:content>
        <div
          v-show="chooseIndex === index"
          v-for="(e, index) in tabList"
          :key="e"
        >
          <month-select
            @getVal="getVal"
            :date="date"
            v-if="e === '月份选择'"
          ></month-select>
          <custom-timer
            @getVal="getVal"
            :date="date"
            v-if="e === '自定义'"
          ></custom-timer>
        </div>
      </template>
    </Popover>
    <self-popup v-model="ShowPopupContent"></self-popup>
  </div>
</template>

<script>
import Popover from '@/components/Popover.vue';
import moment from 'moment';
import { mapState } from 'vuex';
import Card from './components/Card.vue';
import CustomTimer from './components/CustomTimer.vue';
import MonthSelect from './components/MonthSelect.vue';

export default {
  name: 'TransactionRecord',
  data() {
    return {
      orderId: '',
      month: '',
      debitFlag: '',
      tranType: '',
      startDate: '',
      endDate: '',
      pageNum: 0,
      pageSize: 10,
      tranDetailList: [],
      isPopover: false,
      showPicker: false,
      columns: ['全部', '转出', '转入'],
      tabList: ['月份选择', '自定义'],
      ative: 'ative',
      chooseIndex: 0,
      date: moment(new Date()).format('YYYY.MM'),
      status: '', // 1:月份选择 2:交易时间 3自定义
      list: [],
      loading: false,
      finished: false,
      // 弹窗
      ShowPopupContent: '',
    };
  },
  components: {
    Card,
    Popover,
    CustomTimer,
    MonthSelect,
  },
  mounted() {
    this.orderId = this.capitalAccount.orderId;
  },
  computed: {
    ...mapState({
      capitalAccount(val) {
        return val.capitalAccount;
      },
    }),
    transaction() {
      let val = '';
      // eslint-disable-next-line default-case
      switch (this.debitFlag) {
        case '':
          val = '全部';
          break;
        case 0:
          val = '转出';
          break;
        case 1:
          val = '转入';
          break;
      }
      return val;
    },
  },
  methods: {
    onLoad() {
      this.pageNum += 1;
      this.loading = true;
      this.finished = false;
      this.getTranDetailList();
    },
    tranDate(date, time) {
      return date + time;
    },
    getTranDetailList() {
      this.$api.CommonForms.tranDetailList({
        orderId: this.orderId,
        month: this.month ? this.month.split('.').join('') : '',
        tranType: this.tranType,
        startMonth: this.startDate ? this.startDate.split('.').join('') : '',
        endMonth: this.startDate ? this.endDate.split('.').join('') : '',
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: `${this.status}`,
      })
        .then((res) => {
          if (res.success) {
            if (this.pageNum === 1) {
              this.tranDetailList = [];
              this.tranDetailList = [...res.data];
            } else {
              this.tranDetailList = [...this.tranDetailList, ...res.data];
            }
          } else {
            if (res.returnCode !== 'EGG0056') {
              this.ShowPopupContent = res.returnMessage;
            } else if (res.returnCode === 'EGG0056' && this.pageNum === 1) {
              this.tranDetailList = [];
            }
            this.finished = true;
          }
          this.loading = false;
        })
        .catch(() => {
          this.finished = true;
          this.ShowPopupContent = '网络异常，请稍后再试！';
        });
    },
    // 选择交易类型
    seleteTransaction() {
      this.isPopover = true;
    },
    close() {
      this.isPopover = false;
    },
    // 获取自定义选择的值
    getVal(val) {
      const {
        startDate, endDate, tranType, status, month,
      } = val;
      console.log(startDate, endDate, tranType, 'startDate, endDate, tranType');
      if (endDate && startDate) {
        this.date = `${startDate}-${endDate}`;
      } else if (!endDate && startDate) {
        this.date = `${startDate}`;
      } else if (endDate && !startDate) {
        this.date = `${endDate}`;
      }
      if (tranType === 1) {
        this.date = '上个月';
      } else if (tranType === 2) {
        this.date = '近三个月';
      } else if (month) {
        this.date = month;
      }
      this.startDate = startDate;
      this.endDate = endDate;
      this.tranType = tranType;
      this.status = status;
      this.month = month;
      this.pageNum = 0;
      this.pageSize = 10;
      this.onLoad();
      this.isPopover = false;
    },
    clickTabs(e) {
      if (e === 0) {
        this.status = 1;
      }
      this.chooseIndex = e;
    },
  },
};
</script>
<style scoped>
.TransactionRecord {
  display: flex;
  flex-direction: column;
}
.TransactionRecord_head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}
.TransactionRecord_head_allTransaction {
  width: 100px;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #505659;
}
.TransactionRecord_head_date {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #505659;
  padding: 15px 16px;
}
.icon_account {
  color: #001f33;
  margin-left: 3px;
}
.popover_tabs {
  display: flex;
  flex-direction: row;
  position: relative;
}
.active {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
  border-bottom: 3px solid #ff6538 !important;
  padding: 11px 0px;
}
.popover_tabs_item {
  border-bottom: 3px solid #fff;
  padding: 11px 0px;
}
.popover_tabs .popover_tabs_item:last-child {
  margin-left: 20px;
}
.Card_soll {
  flex: 1;
  overflow: hidden;
  margin-top: 60px;
}
.TransactionRecord >>> .van-picker__columns {
  margin-top: 0;
}
</style>
